import React from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import caveatColor from '../caveatColor';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import IconButton from 'material-ui/IconButton/IconButton';
import shallowCompare from 'react-addons-shallow-compare';
import Button from 'material-ui/RaisedButton';
import id from '../reducer/generateID';

class AdditionalCaveatsEditor extends React.Component {
//comment to test commit node16
  constructor(props) {
    super(props);
    this.state = {
      caveats: [...props.caveats].map((c) => ({...c, active: c.title && c.title.length > 0}))
    }
  }

  componentWillReceiveProps(props) {
    if (!this.state.caveats.length && props.caveats && props.caveats.length) {
      this.setState({
        caveats: props.caveats
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }



  render() {
    return (
      <Card style={{width:"90%", margin: "40px auto"}} zDepth={1}>
        <CardHeader title="Additional Caveats" subtitle="These caveats affect scoring and will apply to this option regardless of user answers." />
        <CardText>
          <table style={{borderSpacing: 0, width: "100%"}}>
            <tbody>
            {
              this.state.caveats.map((caveat) => {
                let trstyle = {paddingLeft: 0};
                var tdStyle = {padding: "0px 0px"};
                let colors = caveatColor(caveat.score);
                if (!caveat.active) {
                  colors.primary = "transparent";
                  colors.background = "transparent";
                }
                let firstTdStyle = {...tdStyle};
                firstTdStyle.borderLeft = "4px solid " + colors.primary;
                trstyle.backgroundColor = colors.background;
                return (
                  <tr style={trstyle} key={caveat.id}>
                    <td style={{...firstTdStyle, width: 200}}>
                      <DropDownMenu
                        style={{width: 200}}
                        value={caveat.score || 0}
                        onChange={this.onDropDownMenuChange.bind(this, caveat.id)}
                      >
                        <MenuItem value={2} primaryText="Green (2)" />
                        <MenuItem value={1} primaryText="Purple (1)" />
                        <MenuItem value={0} primaryText="Grey (0)" />
                        <MenuItem value={-1} primaryText="Yellow (-1)" />
                        <MenuItem value={-2} primaryText="Orange (-2)" />
                        <MenuItem value={-3} primaryText="Red (-3)" />
                      </DropDownMenu>
                    </td>
                    <td style={tdStyle}>
                      <TextField
                        ref="title"
                        hintText="Caveat Disabled Without Text"
                        value={caveat.title}
                        onChange={this.onTextChange.bind(this, caveat.id)}
                        style={{marginLeft: 0, marginBottom: -15, width:"95%"}}
                        multiLine={true}
                        rowMax={Infinity}
                      />
                    </td>
                    <td style={tdStyle}>
                      <IconButton style={{top: 8}} tooltip="Delete Caveat" onClick={this.deleteCaveat.bind(this, caveat.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </td>
                  </tr>
                )
              })
            }
            </tbody>
          </table>
          <br />
          <Button label="Add Caveat" onClick={this.addCaveat.bind(this)} />
        </CardText>
      </Card>
    )
  }

  onTextChange(id, el, text) {
    this.updateCaveat(id, {title: text})
  }

  updateCaveat(id, props) {
    let caveat = this.state.caveats.find((c) => c.id === id);
    let index = this.state.caveats.indexOf(caveat);
    let updatedCaveat = {
      ...caveat,
      ...props,
    };
    updatedCaveat.active = updatedCaveat.title.length > 0;
    this.setState({
      caveats: [
        ...this.state.caveats.slice(0, index),
        updatedCaveat,
        ...this.state.caveats.slice(index + 1)
      ]
    })
  }

  deleteCaveat(id) {
    let caveat = this.state.caveats.find((c) => c.id === id);
    let index = this.state.caveats.indexOf(caveat);
    this.setState({
      caveats: [
        ...this.state.caveats.slice(0, index),
        ...this.state.caveats.slice(index + 1)
      ]
    });
  }

  addCaveat() {
    this.setState({
      caveats: [...this.state.caveats, {score: 0, title: "", id: id()}]
    });
  }

  onDropDownMenuChange(id, e, i, value) {
    this.updateCaveat(id, {score: value});
  }


  getValue() {
    return this.state.caveats.flatMap((caveat) => {
      let copy = {...caveat}
      delete caveat.active;
      return (copy.title.length > 0) ? copy : [];
    });
  }

}

export default AdditionalCaveatsEditor;
